import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { Row } from 'react-bootstrap'
import {
  IoIosEye as VisibilityOn,
  IoIosEyeOff as VisibilityOff,
} from 'react-icons/io'
import isMerchPLP from 'config/appConfig'
import { handleFilterCbk } from 'src/deps'
import { merchProductContainer } from 'src/models'
import { application } from 'src/utils'
import { AccordionBlock } from 'src/views/components'
import { ListView } from '../ListView'
import { MobileFilterHeader } from '../MobileFilterHeader'
import './styles.scss'

@observer
class TopFilter extends React.Component {
  // @observable facetFilter = this.props.facetFilter
  @observable filterList = []
  @observable selectedFacet = {
    id: '',
    isActive: '',
  }

  constructor(props) {
    super(props)
    this.filterList = props.facetFilter
  }

  handleReset = () => {
    // console.log('saveData test', merchProductContainer.handleSaveAction())
    // parent.postMessage(
    //   merchProductContainer.handleSaveAction(),
    //   'http://localhost:8080'
    // )
    this.props.handleFilter()
  }

  componentDidUpdate = () => {
    const { facetFilter } = this.props
    this.filterList = facetFilter
  }

  componentDidMount = () => {
    merchProductContainer.setFacetPositions(this.filterList)
  }

  handleClick = (name, value) => {
    if (!isMerchPLP) {
      handleFilterCbk({ props: { ...this.props }, nameValue: { name, value } })
    }
  }

  renderActiveFilter = item => {
    if (item && item.isVisible !== '' && item.isVisible !== undefined) {
      return item.isVisible
    }
    return true
  }

  renderIcon = isOpen => {
    return isOpen ? <VisibilityOn /> : <VisibilityOff />
  }

  handleVisibilityToggle = params => {
    const { selectedFacet, isOpen } = params
    this.selectedFacet = {
      facetId: selectedFacet,
      visible: isOpen,
    }
    this.filterList.forEach((item, index) => {
      const name = item.name !== null ? item.name.toLowerCase() : ''
      if (name === this.selectedFacet.facetId.toLowerCase()) {
        this.filterList[index].isVisible = this.selectedFacet.visible
        this.filterList[index].isActive = isOpen
      } else {
        this.filterList[index].isActive = false
      }
    })
    merchProductContainer.setFacetPositions(this.filterList)
  }

  renderFilterItems = (item, index) => {
    const isActive = isMerchPLP ? this.renderActiveFilter(item) : item.isActive

    return (
      <div>
        <AccordionBlock
          key={`filter-accordion_${index}`}
          className="filter-facet mx-3 my-0 px-0 py-2 border-bottom border-light"
          dataTestId="qa-plp-filter"
          title={item.name}
          // onClick={this.handleAccordionOpenClick}
          renderIcon={isMerchPLP && this.renderIcon}
          isActive={isActive}
          isMerchPLP={isMerchPLP}
          onClick={this.handleVisibilityToggle}
          index={index}>
          {application.isMobile && (
            <ol className="facet-list pt-3 pr-0 pb-0 pl-0">
              <fieldset>
                <legend>{item.name}</legend>
                <ListView
                  item={item}
                  className="check-box-wrap py-md-3 mx-2 text-break text-truncate"
                  handleClick={this.handleClick}
                />
              </fieldset>
            </ol>
          )}
        </AccordionBlock>
      </div>
    )

    // return (
    //   <Draggable
    //     key={item.key}
    //     isDragDisabled={!isMerchPLP}
    //     draggableId={item.key + index}
    //     disableInteractiveElementBlocking={true}
    //     index={index}>
    //     {provided => (
    //       <div
    //         ref={provided.innerRef}
    //         {...provided.draggableProps}
    //         {...provided.dragHandleProps}>
    //         <AccordionBlock
    //           key={`filter-accordion_${index}`}
    //           className="filter-facet mx-3 my-0 px-0 py-2 border-bottom border-light"
    //           dataTestId="qa-plp-filter"
    //           title={item.name}
    //           // onClick={this.handleAccordionOpenClick}
    //           renderIcon={isMerchPLP && this.renderIcon}
    //           isActive={isActive}
    //           isMerchPLP={isMerchPLP}
    //           onClick={this.handleVisibilityToggle}
    //           index={index}>
    //           {application.isMobile && (
    //             <ol className="facet-list pt-3 pr-0 pb-0 pl-0">
    //               <fieldset>
    //                 <legend>{item.name}</legend>
    //                 <ListView
    //                   item={item}
    //                   className="check-box-wrap py-md-3 mx-2 text-break text-truncate"
    //                   handleClick={this.handleClick}
    //                 />
    //               </fieldset>
    //             </ol>
    //           )}
    //         </AccordionBlock>
    //       </div>
    //     )}
    //   </Draggable>
    // )
  }

  renderFilterTitle = () => {
    const { toggleFilter } = this.props
    return (
      <MobileFilterHeader
        toggleFilter={toggleFilter}
        handleReset={this.handleReset}
      />
    )
  }

  // handleFilterArrangement = result => {
  //   let sourceIndex = result.source.index
  //   let destinationIndex = result.destination.index
  //   const sourceData = this.filterList[sourceIndex]
  //   while (destinationIndex !== sourceIndex) {
  //     if (sourceIndex > destinationIndex) {
  //       this.filterList[sourceIndex] = this.filterList[sourceIndex - 1]
  //       sourceIndex = sourceIndex - 1
  //     } else {
  //       this.filterList[sourceIndex] = this.filterList[sourceIndex + 1]
  //       sourceIndex = sourceIndex + 1
  //     }
  //   }
  //   this.filterList[destinationIndex] = sourceData
  //   merchProductContainer.setFacetPositions(this.filterList)
  // }

  // onDragEnd = async result => {
  //   // dropped outside the list
  //   if (!result.destination) {
  //     return
  //   }
  //   console.log('drag and drop final result', result)
  //   await this.handleFilterArrangement(result)
  // }

  // onDrag = prop => {
  //   console.log('start', prop.source.index)
  // }

  // onDragUpdate = () => {
  //   // console.log('update ', prop)
  // }

  render() {
    const facetView =
      this.filterList && this.filterList.map(this.renderFilterItems)
    const selectedFacet = this.filterList.find(facet => {
      return facet.isActive
    })

    return (
      <div className="bg-white py-2 my-2 w-100 top-filter">
        <div className="filter-wrapper w-100 bg-white px-md-3">
          {this.renderFilterTitle()}
          {facetView}
        </div>
        {application.isMobile === false && !!selectedFacet && (
          <Row
            noGutters
            className="mx-3 py-3 my-2 border-top border-dark filter-option-grid">
            <ListView
              className="check-box-wrap py-md-3 mx-2 text-break text-truncate"
              item={selectedFacet}
              handleClick={this.handleClick}
            />
          </Row>
        )}
      </div>
    )

    // return (
    //   <DragDropContext
    //     onDragUpdate={this.onDragUpdate}
    //     onDragStart={this.onDrag}
    //     onDragEnd={this.onDragEnd}>
    //     <Droppable
    //       isDropDisabled={!isMerchPLP}
    //       droppableId="droppable"
    //       direction="horizontal">
    //       {provided => (
    //         <div className="bg-white py-2 my-2 w-100 top-filter">
    //           <div
    //             {...provided.droppableProps}
    //             ref={provided.innerRef}
    //             className="filter-wrapper w-100 bg-white px-md-3">
    //             {this.renderFilterTitle()}
    //             {facetView}
    //           </div>
    //           {application.isMobile === false && !!selectedFacet && (
    //             <Row
    //               noGutters
    //               className="mx-3 py-3 my-2 border-top border-dark filter-option-grid">
    //               <ListView
    //                 className="check-box-wrap py-md-3 mx-2 text-break text-truncate"
    //                 item={selectedFacet}
    //                 handleClick={this.handleClick}
    //               />
    //             </Row>
    //           )}
    //         </div>
    //       )}
    //     </Droppable>
    //   </DragDropContext>
    // )
  }
}

export { TopFilter }
export default TopFilter
